import { render, staticRenderFns } from "./candidate.vue?vue&type=template&id=4500ce18&scoped=true"
import script from "./candidate.vue?vue&type=script&lang=js"
export * from "./candidate.vue?vue&type=script&lang=js"
import style0 from "./candidate.vue?vue&type=style&index=0&id=4500ce18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4500ce18",
  null
  
)

export default component.exports